import React, { createElement, useContext } from 'react';
import Image from '@jetshop/ui/Image';
import { styled } from 'linaria/react';
import { StyledButton } from '../ui/StyledButton';
import { BoxContent } from '../ContentComponents/BoxContent';
import { LinkEvaluator } from '../../utils/LinkEvaluator';
import { PromoCardContext } from './PromoCardContext';

const PromoCardWrapper = styled('div')`
  position: relative;
  height: 100%;
  padding: 0 0.5em 0;
  height: ${props => props.height + 'px'};
  .link-evaluator {
    text-decoration: none;
    color: inherit;
    display: block;
    overflow: hidden;
    position: relative;
  }

  .content-placer {
    padding: 20px !important;
  }
`;

const VideoWrapper = styled('div')`
  position: relative;
  height: 100%;
  height: ${props => props.height + 'px'};
  padding: 0 0.5em 0;

  .link-evaluator {
    text-decoration: none;
    color: inherit;
    display: block;
    position: relative;
    overflow: hidden;
  }

  iframe {
    position: absolute;
    top: -10%;
    left: -10%;
    bottom: -10%;
    right: -10%;
    width: 120%;
    height: 120%;
  }

  .content-placer {
    padding: 20px !important;
  }
`;

const ImagePromoCard = ({ product }) => {
  const { cardHeight } = useContext(PromoCardContext);
  const imageUrl = product.properties?.filter(prop => {
    return prop.name === 'imageUrl';
  })[0]?.value?.value;

  const tintLayer = product.properties?.filter(prop => {
    return prop.name === 'tintLayer';
  })[0]?.value;

  const link = product.properties?.filter(prop => {
    return prop.name === 'link';
  })[0]?.value;

  const textColor = product.properties?.filter(prop => {
    return prop.name === 'textColor';
  })[0]?.value;

  const textAlignment = product.properties?.filter(prop => {
    return prop.name === 'textAlignment';
  })[0]?.value;

  const preHeader = product.properties?.filter(prop => {
    return prop.name === 'preHeader';
  })[0]?.value;

  const header = product.properties?.filter(prop => {
    return prop.name === 'header';
  })[0]?.value;

  const horizontalPosition = product.properties?.filter(prop => {
    return prop.name === 'horizontalPosition';
  })[0]?.value;

  const verticalPosition = product.properties?.filter(prop => {
    return prop.name === 'verticalPosition';
  })[0]?.value;

  const buttonText = product.properties?.filter(prop => {
    return prop.name === 'buttonText';
  })[0]?.value;

  const buttonTheme = product.properties?.filter(prop => {
    return prop.name === 'buttonTheme';
  })[0]?.value;

  const imageBtn = createElement(
    StyledButton,
    {
      key: 'image-box-item-button',
      className: `image-box-button ${buttonTheme?.value ?? 'RED'}`
    },
    buttonText?.value
  );

  return (
    <PromoCardWrapper className={'promo-cards-wrapper'} height={cardHeight}>
      <LinkEvaluator link={link}>
        <Image src={imageUrl} sizes={1 / 4} fillAvailableSpace />
        <BoxContent
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPosition}
          tintLayer={tintLayer}
          color={textColor}
          preHeader={preHeader}
          header={header}
          textAlignment={textAlignment}
          buttonChildren={buttonText?.value ? [imageBtn] : null}
          forType={'image-box'}
        />
      </LinkEvaluator>
    </PromoCardWrapper>
  );
};

const VideoPromoCard = ({ product }) => {
  const { cardHeight } = useContext(PromoCardContext);
  const videoUrl = product.properties?.filter(prop => {
    return prop.name === 'videoUrl';
  })[0]?.value?.value;

  const tintLayer = product.properties?.filter(prop => {
    return prop.name === 'tintLayer';
  })[0]?.value;

  const link = product.properties?.filter(prop => {
    return prop.name === 'link';
  })[0]?.value;

  const textColor = product.properties?.filter(prop => {
    return prop.name === 'textColor';
  })[0]?.value;

  const textAlignment = product.properties?.filter(prop => {
    return prop.name === 'textAlignment';
  })[0]?.value;

  const preHeader = product.properties?.filter(prop => {
    return prop.name === 'preHeader';
  })[0]?.value;

  const header = product.properties?.filter(prop => {
    return prop.name === 'header';
  })[0]?.value;

  const horizontalPosition = product.properties?.filter(prop => {
    return prop.name === 'horizontalPosition';
  })[0]?.value;

  const verticalPosition = product.properties?.filter(prop => {
    return prop.name === 'verticalPosition';
  })[0]?.value;

  const buttonText = product.properties?.filter(prop => {
    return prop.name === 'buttonText';
  })[0]?.value;

  const buttonTheme = product.properties?.filter(prop => {
    return prop.name === 'buttonTheme';
  })[0]?.value;

  const imageBtn = createElement(
    StyledButton,
    {
      key: 'image-box-item-button',
      className: `image-box-button ${buttonTheme?.value ?? 'RED'}`
    },
    buttonText?.value
  );

  var videoId = videoUrl.split('.com/')[1];
  var correctVideoUrl =
    'https://player.vimeo.com/video/' +
    videoId +
    '?background=1&autoplay=1&loop=1&color=ffffff';

  return (
    <VideoWrapper height={cardHeight}>
      <LinkEvaluator link={link}>
        <iframe
          title="Video"
          src={correctVideoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <BoxContent
          verticalPosition={verticalPosition}
          horizontalPosition={horizontalPosition}
          tintLayer={tintLayer}
          color={textColor}
          preHeader={preHeader}
          header={header}
          textAlignment={textAlignment}
          buttonChildren={buttonText?.value ? [imageBtn] : null}
          forType={'image-box'}
        />
      </LinkEvaluator>
    </VideoWrapper>
  );
};

export const PromoCard = ({ product }) => {
  if (product?.type === 'promoCardImageItem') {
    return <ImagePromoCard product={product} />;
  }

  if (product?.type === 'promoCardVideoItem') {
    return <VideoPromoCard product={product} />;
  }
};
